import { Hero } from "./sections/Hero"
import SellingPoint from "./sections/SellingPoint"
import Services from "./sections/Services"
import Contact from "./sections/Contact"
import Reviews from "@/components/Reviews"
import Footer from "@/components/Footer"
import Navbar from "@/components/Navbar"
import SEO from "@/components/SEO"
import LoadingScreen from "@/components/LoadingScreen"
import { useLocation } from "react-router"
import { useEffect, useRef, useState } from "react"
import { getCustomerReviews } from "@/screens/services/NewReviews"
import { useTranslation } from 'react-i18next'

const Home = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const servicesRef = useRef<HTMLElement>(null);
  const contactRef = useRef<HTMLElement>(null);
  const customerReviews = getCustomerReviews(t);
  const [isLoading, setIsLoading] = useState(true);

  // Loading effect
  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 800);

    return () => clearTimeout(timer);
  }, []); // Only trigger on initial mount

  useEffect(() => {
    if (location.hash === "#contact") {
      document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <div>
        <SEO
          title={t('seo.home.title')}
          description={t('seo.home.description')}
          keywords={t('seo.home.keywords')}
          type="website"
          lang={i18n.language as 'ms' | 'en'}
        />
        <Navbar/>
        <Hero servicesRef={servicesRef} contactRef={contactRef} />
        <Services ref={servicesRef} />
        <SellingPoint/>
        <Reviews reviews={customerReviews} />
        <Contact ref={contactRef} />
        <Footer footer_bg="bg-primary-blue" />
    </div>
  )
}

export default Home